module.exports = __webpack_public_path__ + "img/shop-photo3.2e71ec0e.jpg";